import { render, staticRenderFns } from "./CommonMasterList.vue?vue&type=template&id=35787752&scoped=true&"
import script from "./CommonMasterList.vue?vue&type=script&lang=ts&"
export * from "./CommonMasterList.vue?vue&type=script&lang=ts&"
import style0 from "./CommonMasterList.vue?vue&type=style&index=0&id=35787752&scoped=true&lang=css&"
import style1 from "./CommonMasterList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35787752",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VDataTable,VIcon,VImg,VRow,VSpacer})
